import React from "react";
import {
  KunjunganRawatJalan,
  KunjunganRawatInap,
  KunjunganIgd,
  BookingAntrian,
  GabungRM,
} from "./../WrapperLazyExport";

import { REG_RJ, REG_RI, REG_IGD, REG_BA, REG_GRM } from "App/constants";

export const menuRegistrasi = {
  [REG_RJ]: <KunjunganRawatJalan />,
  [REG_RI]: <KunjunganRawatInap />,
  [REG_IGD]: <KunjunganIgd />,
  [REG_BA]: <BookingAntrian />,
  [REG_GRM]: <GabungRM />,
};
